/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Volume_Meta_LbInputs */

const en_us2_progress_volume_meta_lb = /** @type {(inputs: Progress_Volume_Meta_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lb per week`)
};

const pt_br2_progress_volume_meta_lb = /** @type {(inputs: Progress_Volume_Meta_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lb por semana`)
};

const es_419_progress_volume_meta_lb = /** @type {(inputs: Progress_Volume_Meta_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lb por semana`)
};

const pt_pt2_progress_volume_meta_lb = /** @type {(inputs: Progress_Volume_Meta_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lb por semana`)
};

const fr_fr2_progress_volume_meta_lb = /** @type {(inputs: Progress_Volume_Meta_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lb par semaine`)
};

const de_de2_progress_volume_meta_lb = /** @type {(inputs: Progress_Volume_Meta_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lb pro Woche`)
};

const it_it2_progress_volume_meta_lb = /** @type {(inputs: Progress_Volume_Meta_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lb a settimana`)
};

/**
* | output |
* | --- |
* | "lb per week" |
*
* @param {Progress_Volume_Meta_LbInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_volume_meta_lb = /** @type {((inputs?: Progress_Volume_Meta_LbInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Volume_Meta_LbInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_volume_meta_lb(inputs)
	if (locale === "es-419") return es_419_progress_volume_meta_lb(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_volume_meta_lb(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_volume_meta_lb(inputs)
	if (locale === "de-DE") return de_de2_progress_volume_meta_lb(inputs)
	if (locale === "it-IT") return it_it2_progress_volume_meta_lb(inputs)
	return en_us2_progress_volume_meta_lb(inputs)
});
export { progress_volume_meta_lb as "progress.volume_meta_lb" }